export default __webpack_public_path__ + "static/char-s-48-en-3db5b985507897cde08c2144cee36c85.webp";